var render = function render(){
  var _vm$dashboardSEE, _vm$dashboardSEE2, _vm$dashboardSEE$info, _vm$dashboardSEE3, _vm$dashboardSEE3$inf, _vm$dashboardSEE$info2, _vm$dashboardSEE4, _vm$dashboardSEE4$inf, _vm$dashboardSEE$info3, _vm$dashboardSEE5, _vm$dashboardSEE5$inf, _vm$dashboardSEE$info4, _vm$dashboardSEE6, _vm$dashboardSEE6$inf, _vm$dashboardSEE$info5, _vm$dashboardSEE7, _vm$dashboardSEE7$inf;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('p', [_vm._v("Buscar Por:")]), _c('v-row', {
    staticClass: "justify-start mt-3 ml-3"
  }, [_c('v-col', {
    attrs: {
      "cols": 8
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Secretaria Executiva",
      "dense": "",
      "outlined": "",
      "item-text": "nome",
      "item-value": "codigo",
      "return-object": "",
      "items": _vm.form.listaSecretarias
    },
    model: {
      value: _vm.form.filters.secretariaId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "secretariaId", $$v);
      },
      expression: "form.filters.secretariaId"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "btn-group"
  }, [_c('v-col', {
    staticClass: "text-end"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v(" Limpar ")]), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.buscarDashboard
    }
  }, [_vm._v(" Buscar ")])], 1)], 1)], 1), _vm.dashboardSEE != null ? _c('div', {
    staticClass: "mt-7"
  }, [_c('StatusFormacao', {
    attrs: {
      "status-list": (_vm$dashboardSEE = _vm.dashboardSEE) === null || _vm$dashboardSEE === void 0 ? void 0 : _vm$dashboardSEE.statusFormacao,
      "data-hora-info": (_vm$dashboardSEE2 = _vm.dashboardSEE) === null || _vm$dashboardSEE2 === void 0 ? void 0 : _vm$dashboardSEE2.dataHoraInfo
    },
    on: {
      "visualizar-listagem": function ($event) {
        return _vm.openDialogListarComFormacao(null);
      }
    }
  }), _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center"
  }, [_c('div', {
    staticClass: "subtitle-2 mb-2 font-weight-medium"
  }, [_vm._v("Total De Formações")]), _c('div', {
    staticClass: "display-1 font-weight-bold blue--text mb-2"
  }, [_vm._v(_vm._s((_vm$dashboardSEE$info = (_vm$dashboardSEE3 = _vm.dashboardSEE) === null || _vm$dashboardSEE3 === void 0 ? void 0 : (_vm$dashboardSEE3$inf = _vm$dashboardSEE3.info) === null || _vm$dashboardSEE3$inf === void 0 ? void 0 : _vm$dashboardSEE3$inf.totalFormacoes) !== null && _vm$dashboardSEE$info !== void 0 ? _vm$dashboardSEE$info : 0))]), _c('v-btn', {
    attrs: {
      "outlined": "",
      "small": "",
      "color": "blue"
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogListarFormacoes();
      }
    }
  }, [_vm._v("Visualizar Listagem")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center"
  }, [_c('div', {
    staticClass: "subtitle-2 mb-2 font-weight-medium"
  }, [_vm._v("Participantes")]), _c('div', {
    staticClass: "display-1 font-weight-bold orange--text mb-2"
  }, [_vm._v(_vm._s((_vm$dashboardSEE$info2 = (_vm$dashboardSEE4 = _vm.dashboardSEE) === null || _vm$dashboardSEE4 === void 0 ? void 0 : (_vm$dashboardSEE4$inf = _vm$dashboardSEE4.info) === null || _vm$dashboardSEE4$inf === void 0 ? void 0 : _vm$dashboardSEE4$inf.totalParticipantes) !== null && _vm$dashboardSEE$info2 !== void 0 ? _vm$dashboardSEE$info2 : 0))]), _c('v-btn', {
    attrs: {
      "outlined": "",
      "small": "",
      "color": "orange"
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogListarParticipantes();
      }
    }
  }, [_vm._v("Visualizar Listagem")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center"
  }, [_c('div', {
    staticClass: "subtitle-2 mb-2 font-weight-medium"
  }, [_vm._v("Média De Frequência")]), _c('div', {
    staticClass: "display-1 font-weight-bold green--text mb-9"
  }, [_vm._v(_vm._s((_vm$dashboardSEE$info3 = (_vm$dashboardSEE5 = _vm.dashboardSEE) === null || _vm$dashboardSEE5 === void 0 ? void 0 : (_vm$dashboardSEE5$inf = _vm$dashboardSEE5.info) === null || _vm$dashboardSEE5$inf === void 0 ? void 0 : _vm$dashboardSEE5$inf.mediaFrequencia) !== null && _vm$dashboardSEE$info3 !== void 0 ? _vm$dashboardSEE$info3 : 0) + "%")])])], 1)], 1), _c('v-row', {
    staticClass: "fill-height",
    staticStyle: {
      "height": "500px"
    }
  }, [_c('v-col', {
    staticClass: "fill-height",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center fill-height",
    staticStyle: {
      "height": "95%"
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_vm._v("Formações")]), _c('PieChart', {
    attrs: {
      "chartData": _vm.dataPizza
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-row', {
    staticClass: "fill-height"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-card', {
    staticClass: "fill-height d-flex flex-column justify-center align-center"
  }, [_c('div', [_vm._v("Presenças")]), _c('div', {
    staticClass: "d-flex justify-center align-center mt-2"
  }, [_c('div', {
    staticClass: "display-1 font-weight-bold mr-3"
  }, [_vm._v(_vm._s((_vm$dashboardSEE$info4 = (_vm$dashboardSEE6 = _vm.dashboardSEE) === null || _vm$dashboardSEE6 === void 0 ? void 0 : (_vm$dashboardSEE6$inf = _vm$dashboardSEE6.info) === null || _vm$dashboardSEE6$inf === void 0 ? void 0 : _vm$dashboardSEE6$inf.totalPresencas) !== null && _vm$dashboardSEE$info4 !== void 0 ? _vm$dashboardSEE$info4 : 0))]), _c('v-icon', {
    attrs: {
      "large": "",
      "color": "green"
    }
  }, [_vm._v("mdi-check-circle-outline")])], 1)])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-card', {
    staticClass: "fill-height d-flex flex-column justify-center align-center"
  }, [_c('div', [_vm._v("Ausências")]), _c('div', {
    staticClass: "d-flex justify-center align-center mt-2"
  }, [_c('div', {
    staticClass: "display-1 font-weight-bold mr-3"
  }, [_vm._v(_vm._s((_vm$dashboardSEE$info5 = (_vm$dashboardSEE7 = _vm.dashboardSEE) === null || _vm$dashboardSEE7 === void 0 ? void 0 : (_vm$dashboardSEE7$inf = _vm$dashboardSEE7.info) === null || _vm$dashboardSEE7$inf === void 0 ? void 0 : _vm$dashboardSEE7$inf.totalAusencias) !== null && _vm$dashboardSEE$info5 !== void 0 ? _vm$dashboardSEE$info5 : 0))]), _c('v-icon', {
    attrs: {
      "large": "",
      "color": "red"
    }
  }, [_vm._v("mdi-clock-time-four-outline")])], 1)])], 1)], 1)], 1)], 1), _c('v-row', [_c('v-col', {
    staticClass: "fill-height",
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center fill-height",
    staticStyle: {
      "height": "100%"
    }
  }, [_vm.funcoesChartData.length > 0 ? [_c('HorizontalBarChartSimple', {
    attrs: {
      "rawData": _vm.funcoesChartData,
      "height": _vm.stackedChartHeightFunctions,
      "formatAsPercent": false,
      "title": "Maiores Quantidades de Funções em Formação"
    }
  })] : [_c('p', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v("Não há dados!")])]], 2)], 1), _c('v-col', {
    staticClass: "fill-height",
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center fill-height",
    staticStyle: {
      "height": "100%"
    }
  }, [_vm.frequenciaChartData.length > 0 ? [_c('HorizontalBarChartSimple', {
    attrs: {
      "rawData": _vm.frequenciaChartData,
      "height": _vm.stackedChartHeight,
      "formatAsPercent": true,
      "title": "Frequência por Formação"
    }
  })] : [_c('p', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v("Não há dados!")])]], 2)], 1)], 1), _c('v-row', {
    staticClass: "btn-group"
  }, [_c('v-col', {
    staticClass: "text-end"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.exportarDadosPdf
    }
  }, [_vm._v(" Exportar Gráficos ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm.dialogListarFormacaoPorStatusDialog.visible ? _c('ListarFormacaoPorStatusDialog', {
    attrs: {
      "visible": _vm.dialogListarFormacaoPorStatusDialog.visible,
      "content": _vm.dialogListarFormacaoPorStatusDialog.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogListarFormacaoPorStatusDialog.close();
      }
    }
  }) : _vm._e(), _vm.dialogListarFormacoes.visible ? _c('ListarFormacoesDialog', {
    attrs: {
      "visible": _vm.dialogListarFormacoes.visible,
      "content": _vm.dialogListarFormacoes.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogListarFormacoes.close();
      }
    }
  }) : _vm._e(), _vm.dialogListarParticipantes.visible ? _c('ListarParticipantesDialog', {
    attrs: {
      "visible": _vm.dialogListarParticipantes.visible,
      "content": _vm.dialogListarParticipantes.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogListarParticipantes.close();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }